module.exports = __webpack_public_path__ + "img/level-6.bfb2c12e.svg";